import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class SimpleCacheService {

    private cache: Map<string, any> = new Map<string, any>();

    put(key: string, value: any) {
        // console.logByType['put in cache ' + key, value]);
        if (this.cache.has(key)) {
            this.cache.delete(key);
        }

        this.cache.set(key, value);

        // console.logByType['cache state', this.cache])
    }

    getValue(key: string): any {
        // console.logByType['get value ' + key, this.cache.get(key)]);
        return this.cache.get(key);
    }

    clear() {
        this.cache.clear();
    }

}